'use es6';

import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import React from 'react';
import classNames from 'classnames';
import ButtonStates from '../constants/ButtonStates';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import UIIconHolder from 'UIComponents/icon/UIIconHolder';
export default createReactClass({
  displayName: "SaveButton",
  propTypes: {
    buttonState: PropTypes.oneOf([ButtonStates.INITIAL, ButtonStates.SAVING, ButtonStates.COMPLETE]).isRequired,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    textPath: PropTypes.string.isRequired,
    use: PropTypes.string
  },
  getDefaultProps: function getDefaultProps() {
    return {
      className: '',
      disabled: false,
      use: 'primary'
    };
  },
  render: function render() {
    var _this$props = this.props,
        buttonState = _this$props.buttonState,
        className = _this$props.className,
        disabled = _this$props.disabled,
        onClick = _this$props.onClick,
        textPath = _this$props.textPath,
        use = _this$props.use;
    var saveButtonClasses = classNames('save-button', className);
    return React.createElement(UILoadingButton, {
      className: saveButtonClasses,
      disabled: disabled,
      loading: buttonState === ButtonStates.SAVING,
      onClick: onClick,
      use: use
    }, buttonState === ButtonStates.COMPLETE && React.createElement(UIIconHolder, {
      name: "success"
    }), React.createElement(FormattedMessage, {
      message: textPath + ".saveButtonText." + buttonState
    }));
  }
});